module.exports = __webpack_public_path__ + "static/media/ekran-powietrze.04444942.svg";